import AvailablePricesSettings from './AvailablePricesSettings';
export default class Filters {
	constructor(props){
		const {availablePricesSettings}=props;
		this._availablePricesSettings = availablePricesSettings;
	}
	get availablePricesSettings(){
		return this._availablePricesSettings;
	}
	static fromJSON(jObject){
		return new Filters({availablePricesSettings: AvailablePricesSettings.fromJSON(jObject.availablePrices)});
	}
}
